// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"ff6a00a9","453":"10d3c063"}[chunkId] + ".chunk.js";
};